// NOTE: Only used by legacy code.
export enum MetricUserPlan {
    Paid = 'paid',
    Free = 'free',
    Anonymous = 'anonymous',
    Unknown = 'unknown',
}
